import React, { FC } from 'react';

import { SkeletonLoaderV2 } from '../../molecules/SkeletonLoaderV2';
import { SKELETON_ROW_COUNT, WALLET_SAVED_CARDS_TEST_IDS } from './WalletSavedCardsSection.constants';

// Geometry mirrors the populated row so layout doesn't shift when data arrives.
export const SkeletonRows: FC<{ rowCount?: number }> = ({ rowCount = SKELETON_ROW_COUNT }) => {
  return (
    <div
      className="wallet-saved-cards-section__cards-list"
      data-testid={WALLET_SAVED_CARDS_TEST_IDS.skeletonList}
      aria-busy="true"
      aria-live="polite"
    >
      {Array.from({ length: rowCount }).map((_, index) => {
        const isLast = index === rowCount - 1;
        return (
          <div
            key={`saved-card-skeleton-${index}`}
            className={`wallet-saved-card-row wallet-saved-cards-section__row--skeleton d-flex align-items-center${
              isLast ? '' : ' wallet-saved-cards-section__row--bordered'
            }`}
            data-testid={WALLET_SAVED_CARDS_TEST_IDS.skeletonRow(index)}
          >
            <SkeletonLoaderV2 className="wallet-saved-cards-section__row-thumbnail-skeleton" />
            <div className="wallet-saved-cards-section__row-text flex-grow-1">
              <SkeletonLoaderV2 className="wallet-saved-cards-section__row-number-skeleton" />
              <SkeletonLoaderV2 className="wallet-saved-cards-section__row-name-skeleton" />
            </div>
            <SkeletonLoaderV2 className="wallet-saved-cards-section__row-cta-skeleton" />
          </div>
        );
      })}
    </div>
  );
};
